import { useEffect, useRef, useState } from "react";

const DEFAULT_RETAIN_MS = 250;

export function useRetainedValue<T>(value: T, retainMs?: number): T;
export function useRetainedValue<T>(value: T | null, retainMs?: number): T | null;
export function useRetainedValue<T>(value: T | undefined, retainMs?: number): T | undefined;
export function useRetainedValue<T>(value: T | null | undefined, retainMs = DEFAULT_RETAIN_MS) {
  const [retainedValue, setRetainedValue] = useState(value);
  const clearTimeoutRef = useRef<ReturnType<typeof window.setTimeout> | null>(null);

  useEffect(() => {
    if (clearTimeoutRef.current) {
      window.clearTimeout(clearTimeoutRef.current);
      clearTimeoutRef.current = null;
    }

    if (value != null) {
      setRetainedValue(value);
      return;
    }

    clearTimeoutRef.current = window.setTimeout(() => {
      setRetainedValue(value);
      clearTimeoutRef.current = null;
    }, retainMs);

    return () => {
      if (clearTimeoutRef.current) {
        window.clearTimeout(clearTimeoutRef.current);
        clearTimeoutRef.current = null;
      }
    };
  }, [retainMs, value]);

  useEffect(() => {
    return () => {
      if (clearTimeoutRef.current) {
        window.clearTimeout(clearTimeoutRef.current);
      }
    };
  }, []);

  return retainedValue;
}
